import { HighchartsReact } from "highcharts-react-official";
import Highcharts from 'highcharts/highstock';
import { CMTrackChart, CMTrackChartContainer, CMTrackItem, CMTracksContainer, CMTracksPerformance } from "./track-performance.styles";
import { MainBox } from "../../../theme/global.styles";
import { useEffect, useState } from "react";
import { TRACKS_PERFORMANCE } from "../../../Services/fake/tracks-performance";
import moment from "moment/moment";


const TRACKS_COLORS = ['#eca570', '#30d5c8', '#ff0000', '#b8428c', '#ee8b97', '#742796', '#c4a484', '#808080']

const initialData = {
    rangeSelector: {
      allButtonsEnabled: true,
      selected: 2
    },
    title: {
      text: ''
    },
    tooltip: {
      useHTML: true,
      shared: true,
      borderWidth: 1,
      backgroundColor: 'white',
      borderColor: '#B5CAE1',
      borderRadius: 10,
      split: false,
    },
    plotOptions: {
      series: {
        turboThreshold: 2000000
      }
    },
    xAxis: {
      title: {
        text: ''
      },
      labels: {
        formatter: function() {
          return Highcharts.dateFormat('%m/%d/%Y', this.value);
        }
      },
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    series: [],
};

const TrackPerformance = ({auction}) => {
    const [data, setData] = useState(initialData);

    useEffect(() => {
        let tmpData = {...initialData};
        tmpData.series = [];
        
        auction.tracks?.map((track, index) => {
          if(track.trackScore) {
            const tmpValues = track.trackScore.all.map(item => {
              return {
                x: new Date(item.timestp).getTime(),
                y: item.value
              };
            });
  
          
            const residue = index % TRACKS_COLORS.length === 0;
            const colorIndex = residue ? 0 : index % TRACKS_COLORS.length;
            
            tmpData.series.push({
              name: track.title,
              data: tmpValues, 
              lineColor: TRACKS_COLORS[colorIndex],
            });
          }

        });

        setData(tmpData);
    },[]);

    return (
        <CMTracksPerformance>
           
        </CMTracksPerformance>
    )
}

export default TrackPerformance;